// External Dependencies
import React from 'react';
import IconButton from 'material-ui/IconButton';
import MailOutlineIcon from 'material-ui/svg-icons/communication/mail-outline';
import moment from 'moment';
import {
  grey900,
  lightBlueA400,
  red400,
} from 'material-ui/styles/colors';

// Local Dependencies
import FacebookIcon from '../../shared/icons/facebook-box';
import TwitterIcon from '../../shared/icons/twitter-box';

// Local Variables
const linkStyle = {
  color: red400,
  textDecoration: 'none',
};

const footerStyles = {
  textAlign: 'center',
  fontSize: '8pt',
  color: lightBlueA400,
  padding: '20px',
  background: grey900,
  // bottom: '0',
};

const iconContainerStyle = {
  textAlign: 'center',
  width: '100%',
};

const iconStyles = {
  height: 32,
  width: 32,
};

const footerTextStyles = {
  fontSize: 16,
  paddingTop: 20,
};

const currentYear = moment().year();
const mailIcon = <MailOutlineIcon color="white" />;

// Component Definition
const FooterContent = () => (
  <div style={footerStyles}>
    <div style={iconContainerStyle}>
      <IconButton
        href="https://www.facebook.com/FriscoCoderDojo/"
        iconStyle={iconStyles}
      >
        <FacebookIcon />
      </IconButton>
      <IconButton
        href="https://twitter.com/friscocoderdojo"
        iconStyle={iconStyles}
      >
        <TwitterIcon />
      </IconButton>
      <IconButton
        href="mailto:dojo@call-em-all.com?subject=From the Frisco Coder Dojo website"
        iconStyle={iconStyles}
        tooltip="Get in touch with us!"
        tooltipPosition="top-center"
      >
        {mailIcon}
      </IconButton>
    </div>
    <div style={footerTextStyles}>
      &copy; Copyright 2016-{currentYear} Frisco Coder Dojo |&nbsp;
      <a
        href="https://www.call-em-all.com/"
        rel="noopener noreferrer"
        style={linkStyle}
        target="_blank"
      >
        Call-Em-All
      </a>
    </div>
  </div>
);

export default FooterContent;



/** WEBPACK FOOTER **
 ** ./src/shared/footer/index.js
 **/